/** Intro copy from the mobile cheatsheet screens, keyed by web slug. */
export const SHEET_INTROS: Record<string, string> = {
  'useful-terms': 'Here are key words and phrases that every beginner should learn.',
  'basic-vocabulary': 'Expanding your vocabulary by learning new words can sharpen your communication!',
  'asking-questions': 'Here are two main ways to ask questions in Hmong.',
  reduplication:
    'Hmong uses reduplication, or repeating a word to indicate intensity. Repeating a word can make the sentence sound stronger, more emotional, or vivid.',
  conjunctions: 'Learn how to connect words, phrases, or sentences to create a complete thought.',
  negation: "Let's practice with a few examples!",
  'verb-tenses':
    'Hmong verbs do not change according to tense, number, or person. Time indicators are often added to show when an action takes place.',
  'time-indicators':
    'Time indicators are used to communicate when something happens. They help convey when an event is happening in the past, present, or future.',
  'intro-to-siab': 'Here are common phrases using siab to describe aspects of personality or emotional state.',
  'intro-to-hmong-tones':
    'Listen to how each tone can change the sound of a single vowel. Find patterns to distinguish each sound.',
  'english-vs-hmong-tones':
    'English tones modify how something is said, while Hmong tones change what is being said.',
  'hmong-tone-examples':
    'Hmong tones change the meaning of words. Here are examples of how different tones affect word meanings in Hmong.',
  'word-families': 'Word families group Hmong words that share a vowel or ending.',
  'hmong-classifiers':
    'Hmong classifiers help categorize nouns and are required when specifying objects. Here are some common classifiers.',
  'subject-verb-object': 'Hmong sentences usually follow a subject–verb–object order.',
  'everyday-useful-words-ii': 'Here are more essential words that will expand your Hmong vocabulary.',
  'everyday-useful-phrases-ii': 'Here are more essential phrases that will help you in everyday conversations.',
};
